import React, { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import { Container, Nav, Navbar, NavbarBrand, NavLink } from 'react-bootstrap';
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';
import NavbarToggle from 'react-bootstrap/esm/NavbarToggle';

export default function NavbarComp() {
    const [navbarBg, setNavbarBg] = useState('light')
    const [expanded, setExpanded] = useState(false);

    useEffect(()=>{
        window.addEventListener('scroll', ()=>{
            if(window.scrollY > 40){
                setNavbarBg('dark')
            }
            else{
                setNavbarBg('light')
            }
        })
    },[])
	return (
		<div>
			<Navbar
				collapseOnSelect
				expand='md'
                expanded={expanded}
				bg={navbarBg}
				variant={navbarBg}
				fixed='top'
				className='pt-3 pb-3'
			>
				<Container>
					<NavbarBrand className='fs-3 navbar-light navbar-title'>Dr.Emad</NavbarBrand>
					<NavbarToggle aria-controls='responsive-navbar-nav' onClick={() => setExpanded(expanded ? false : "expanded")} />
					<NavbarCollapse id='responsive-navbar-nav'>
						<Nav className='me-auto'></Nav>
						<Nav>
							{/* <LinkContainer to='/'> */}
							<NavLink className='fs-6'>
								<HashLink to='/#home' className='navbar-link' onClick={() => setExpanded(false)}>HOME</HashLink>
							</NavLink>
							{/* </LinkContainer> */}
							{/* <LinkContainer to='/about'> */}
							<NavLink className='fs-6'>
								<HashLink to='/about' className='navbar-link' onClick={() => setExpanded(false)}>ABOUT</HashLink>
							</NavLink>
							{/* </LinkContainer> */}
							{/* <LinkContainer to='/services'> */}
							<NavLink className='fs-6'>
								<HashLink to='/home#services' className='navbar-link' onClick={() => setExpanded(false)}>SERVICES</HashLink>
							</NavLink>
                            {/* </LinkContainer> */}
							{/* <LinkContainer to='/our-team'> */}
							<NavLink className='fs-6'>
								<HashLink to='/our-team' className='navbar-link' onClick={() => setExpanded(false)}>TEAM</HashLink>
							</NavLink>
							{/* </LinkContainer>
							<LinkContainer to='/my-blog'> */} 
							<div className='fs-6 blog-link'>
								<a href='https://www.beingaware.co.in/' rel="noreferrer" target={'_blank'} className='navbar-link' >MY BLOG</a>
							</div>
							{/* </LinkContainer>
							<LinkContainer to='/contact'> */}
							<NavLink className='fs-6'>
								<HashLink to='/home#contact' className='navbar-link' onClick={() => setExpanded(false)}>CONTACT</HashLink>
							</NavLink>
							{/* </LinkContainer> */}
						</Nav>
					</NavbarCollapse>
				</Container>
			</Navbar>
		</div>
	);
}
